/**
 *
 * @description: Manage Services And Prices Table data
 *
 */
import {mapActions, mapGetters} from "vuex";
import animateScrollTo from "animated-scroll-to";

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters(["departmentsDetail", "priceAndServices"]),
    },
    methods: {
        ...mapActions(["fetchDepartmentsDetail", "fetchPriceAndServices"]),
        currentPage(value) {
            const query = {...this.$route.query};
            query.page = value;
            value ? this.$router.replace({query}) : '';
        },
        scroll() {
            animateScrollTo(document.getElementById("scrollTo"));
        },
        sortData(value) {
            let query = {...this.$route.query};
            if (query.hasOwnProperty('order_by') && query["order_by"] === value) {
                // Delete If Filter Already Clicked
                query["order_by"] = "-" + value;
                query.page = 1
                this.$router.replace({
                    query: query
                });
            } else {
                query["order_by"] = value
                query.page = 1;

                // Update router
                this.$router.replace({
                    query: query
                });
            }
        }
    },
    watch: {
        $route(to) {
            this.fetchPriceAndServices({
                departmentUrl: this.$route.name === 'Оформление справок' ? 'справки' : this.$route.params.slug || '',
                page: to.query.page,
                order_by: to.query.order_by,
                name: to.query.name || '',
                type: to.query.type || '',
            })
        }
    },
    mounted() {
        this.fetchPriceAndServices({
            departmentUrl: this.$route.name === 'Оформление справок' ? 'справки' : this.$route.params.slug || '',
            page: this.$route.query.page || 1,
            order_by: this.$route.query.order_by,
            name: this.$route.query.name || '',
            type: this.$route.query.type || '',
        })
    }
}
